import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Star, ChevronRight, Phone, ArrowRight, Quote, Filter } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const CHRIS_PHOTO = "https://customer-assets.emergentagent.com/job_a0897f07-e635-4cd5-9eb9-21140ceaa71c/artifacts/drlh8cs0_brookebarclayphotography-1-99.jpg";

// All 28 Real Zillow Reviews
const ZILLOW_REVIEWS = [
  {
    name: "M. Bronnes",
    rating: 5,
    text: "I walked into his office and said I would like to sell my house. Chris started the process and it went very fast. He and his photographer came over and put together a very nice presentation of my home online. Once the buyer got involved, Chris worked with them and myself to speed up the process.",
    location: "Grays Harbor, WA",
    type: "Seller",
    date: "Dec 2025",
    source: "Zillow"
  },
  {
    name: "Eva Board",
    rating: 5,
    text: "Chris was amazing! Buying a house is not always an easy process and he was there the whole way, keeping us updated, giving honest opinions and recommendations on houses and fighting for the things we want with realistic expectations. Chris has been our real estate agent through 2 transactions now.",
    location: "Aberdeen, WA",
    type: "Buyer & Seller",
    date: "Nov 2025",
    source: "Zillow"
  },
  {
    name: "Angela McCullough",
    rating: 5,
    text: "Chris did an excellent job from beginning to end! He was knowledgeable and responsive at every turn. We love our new home and 100 percent recommend Chris!",
    location: "Ocean Shores, WA",
    type: "Buyer",
    date: "Aug 2025",
    source: "Zillow"
  },
  {
    name: "Christian Laines",
    rating: 5,
    text: "Chris did a great job in listing my property and getting it sold. He was very knowledgeable, advised on specific subjects when needed, and always knew when and how to negotiate with the other party. Chris is an example of a knowledgeable Realtor who knows his area and knows how to get the job done.",
    location: "Aberdeen, WA",
    type: "Seller",
    date: "Aug 2025",
    source: "Zillow"
  },
  {
    name: "Spaammme",
    rating: 5,
    text: "Chris is easy to work with and very efficient in everything dealing with our land evaluation. He came up with a CMA and potential options for our vacant land which had few local comparable properties.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Apr 2025",
    source: "Zillow"
  },
  {
    name: "Mike & Cheri Brown",
    rating: 5,
    text: "Chris was fabulous. Great to deal with and very knowledgeable of the area and the issues surrounding buying and selling of houses and properties. Thank you very much Chris!",
    location: "Cosmopolis, WA",
    type: "Seller",
    date: "Apr 2025",
    source: "Zillow"
  },
  {
    name: "Shana Conrad",
    rating: 5,
    text: "Chris did an amazing job helping to guide through the process of buying a house. He was very knowledgeable and was willing to answer all our questions. If you need a local realtor 100% choose Chris.",
    location: "Montesano, WA",
    type: "Buyer",
    date: "Mar 2025",
    source: "Zillow"
  },
  {
    name: "Chris Haase",
    rating: 5,
    text: "Chris made the whole long process very clear and bearable! After the closing, Chris is helping me with local knowledge…such as contractors, and lots of help with questions for the county.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Mar 2025",
    source: "Zillow"
  },
  {
    name: "Linsey Bale",
    rating: 5,
    text: "Chris did a wonderful job during the whole selling process. He was quick to respond and offer his knowledge to each situation that came up. He was honest and worked hard.",
    location: "Aberdeen, WA",
    type: "Seller",
    date: "Mar 2025",
    source: "Zillow"
  },
  {
    name: "Lily Cruz-Sellers",
    rating: 5,
    text: "Chris was friendly and knowledgeable! He always made us feel comfortable and well taken care of. Chris has helped us view homes and assisted us in making an offer on a house. He helped negotiate price and answered all the questions we had during this process.",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Mar 2025",
    source: "Zillow"
  },
  {
    name: "Twincessa Holdings",
    rating: 5,
    text: "Chris was a phenomenal REA with much knowledge on the area. He was kind and flexible and stuck with us through the whole process! We loved having him be a part of our forever home purchase in Montesano! Thanks Chris!!",
    location: "Montesano, WA",
    type: "Buyer",
    date: "Jan 2025",
    source: "Zillow"
  },
  {
    name: "Anonymous Buyer",
    rating: 5,
    text: "Chris is an outstanding realtor, he made the home-buying process easier than we expected. He even showed us a house before getting pre-approved and helped provide valuable guidance on obtaining pre-approval through a trusted lender. He was also able to get us a new roof before closing!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Dec 2024",
    source: "Zillow"
  },
  {
    name: "Nick Welch",
    rating: 5,
    text: "Chris is amazing! Chris helped me sell my mother and father's dream home after they passed away. They built it how they wanted it on a somewhat unique riverfront property which made it a little challenging, but Chris was there for me throughout the entire process.",
    location: "Montesano, WA",
    type: "Seller",
    date: "Dec 2024",
    source: "Zillow"
  },
  {
    name: "Michael Buley",
    rating: 5,
    text: "We are really pleased with Chris. He was the listing agent for our home in Montesano. He instills confidence, and a calm approach to everything. He clearly knows the market, the area, the process. And he's just a wonderful man to work with. Absolutely would recommend Chris to anyone.",
    location: "Montesano, WA",
    type: "Seller",
    date: "Nov 2024",
    source: "Zillow"
  },
  {
    name: "Deborah Frederick-Zambetti",
    rating: 5,
    text: "Working with Chris was such a great experience! He always kept us informed on where we were at in the process and answered all of our questions no matter how big or small they were. He is very knowledgeable in all areas of the real-estate industry. He was wonderful to work with!",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Mar 2024",
    source: "Zillow"
  },
  {
    name: "Chase Caterina",
    rating: 5,
    text: "Chris was great to work with! This wasn't our first house purchase and it wasn't our easiest house purchase, but it was the BEST one. Chris worked hard to help get our deal done. He was responsive, pleasant, knowledgeable, and never left us wondering what was going on.",
    location: "Hoquiam, WA",
    type: "Buyer",
    date: "Feb 2024",
    source: "Zillow"
  },
  {
    name: "Sarah Carlson",
    rating: 5,
    text: "Chris helped me facilitate the sale of my duplex with my own goals in mind. He has also helped me consider a variety of other properties to determine if they are aligned with my real estate needs and goals by showing me the properties, finding me potential properties, and brainstorming with me.",
    location: "Spokane, WA",
    type: "Seller",
    date: "Mar 2023",
    source: "Zillow"
  },
  {
    name: "Dalton Willis",
    rating: 5,
    text: "Speaking with Chris has been an immense help with getting my real estate investing portfolio started. He has had the answer to all of my questions along the way.",
    location: "Ocean Shores, WA",
    type: "Buyer",
    date: "Mar 2023",
    source: "Zillow"
  },
  {
    name: "Adriana Farr",
    rating: 5,
    text: "My husband and I got to work with Chris Pierog from the Spivey Real Estate Group and we had a great experience. Chris was so patient throughout the house hunting process and was always willing to show us a house. He was very thorough and walked us through every step of the way.",
    location: "Montesano, WA",
    type: "Buyer",
    date: "Mar 2023",
    source: "Zillow"
  },
  {
    name: "Jon Grice",
    rating: 5,
    text: "Chris was willing to go all over Washington state in order to help us find our ideal home. If you are looking for investment property in the Grays Harbor area, we would highly recommend him.",
    location: "Toledo, WA",
    type: "Buyer",
    date: "Mar 2023",
    source: "Zillow"
  },
  {
    name: "Perry Connor",
    rating: 5,
    text: "Chris helped me buy my first house a few months ago and is very knowledgeable, patient and great to work with! He helped me find a home I love within my budget and I highly recommend his services!",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Jan 2022",
    source: "Zillow"
  },
  {
    name: "Jo Sambro",
    rating: 5,
    text: "My wife and I think of Chris as a super-agent for Coastal Washington. We spent about two months searching for houses with Chris in Grays Harbor and Pacific County during a super-heated market, driving up from Portland on weekends to search. Chris was always able to help us.",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Apr 2021",
    source: "Zillow"
  },
  {
    name: "Anonymous Seller",
    rating: 5,
    text: "Chris was an amazing part of our selling experience. He was there to answer any questions that we had and to help calm our fears of the unknown. He has a great support system with Spivey Realty. They were behind him for support the entire way. Thank you Chris!",
    location: "Elma, WA",
    type: "Seller",
    date: "Dec 2020",
    source: "Zillow"
  },
  {
    name: "Justin Philbrick",
    rating: 5,
    text: "Chris is AMAZING! He is hands down the best realtor I have ever come across. His local area knowledge is unsurpassed and he really goes out of his way to make sure everything is perfect and exactly what you're looking for. I recommend him to all my friends and family.",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Nov 2020",
    source: "Zillow"
  },
  {
    name: "Aquaman",
    rating: 5,
    text: "Chris was an excellent choice for a real estate agent to find us a duplex for me and my family member. We needed a unit that was all on one floor that was close in, yet with small yards, with two one car garages. We looked at all his options until we found the perfect place.",
    location: "Tacoma, WA",
    type: "Buyer",
    date: "Nov 2020",
    source: "Zillow"
  },
  {
    name: "Orgelspieler",
    rating: 5,
    text: "His knowledge of the local area is unparalleled and he was always responsive and invested in the process from the beginning through closing and beyond. We happened upon him and Spivey Realty by happenstance and only in hindsight realized just how fortunate we were.",
    location: "Hoquiam, WA",
    type: "Buyer",
    date: "May 2020",
    source: "Zillow"
  },
  {
    name: "Anonymous Buyer",
    rating: 5,
    text: "Chris is awesome. He did an incredible amount of handholding and helped us through the process of finding and bidding on several homes before we found the perfect place at our price point. I would wholeheartedly recommend him as an agent.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "May 2020",
    source: "Zillow"
  },
  {
    name: "Megan Friberg",
    rating: 5,
    text: "Chris was very helpful, easy to communicate with, and answered any and all questions we had while looking for housing to fit our needs. I highly recommend Chris to anyone looking to buy or sell a home.",
    location: "Montesano, WA",
    type: "Buyer",
    date: "Mar 2019",
    source: "Zillow"
  },
];

// All 51 Real Google Reviews (with corrected dates)
const GOOGLE_REVIEWS = [
  {
    name: "Timothy Laizure",
    rating: 5,
    text: "Chris is an amazing Realtor. He made the process of buying my home in Aberdeen, WA virtually painless. I highly recommend his expertise and will absolutely use his services in the future.",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Tristan Simpson",
    rating: 5,
    text: "Chris is an amazing asset to this team and to the area! If you want a realtor who knows the area and is not pushy to get you to buy, Chris is your guy. Patient and knowledgeable support through the entire process.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "John Lunke",
    rating: 5,
    text: "Chris went the extra mile to find us a house. Actually he drove two hours out of his way to look at a house for us. We told Chris what we wanted and he found it.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Sean Sinclair",
    rating: 5,
    text: "Best realtor I have hired in 30 years of home ownership. This is my 4th home - he did a fantastic job! I highly recommend him.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Michelle Pierog",
    rating: 5,
    text: "I've known Chris Pierog for over a decade, and I can honestly say his dedication to his clients and knowledge of Grays Harbor real estate is exceptional. He truly cares about helping people find the right home.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "TimDee Troeh",
    rating: 5,
    text: "Excellent realtor. Customer service is impressive.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Sarah Carlson",
    rating: 5,
    text: "Five-star experience with Chris!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Andrew Friberg",
    rating: 5,
    text: "I've had the privilege of working with Chris on several home-buying and selling journeys over the years. Having bought and sold multiple properties with him, I can confidently say he's the best in Grays Harbor.",
    location: "Grays Harbor, WA",
    type: "Buyer & Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Debbi Lawton",
    rating: 5,
    text: "Chris was my realtor while I still lived out of town. It was also during COVID. He worked very hard to find me houses to look at and was always available to show me properties when I could make it to town.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "RoseMary Abbott",
    rating: 5,
    text: "The most friendly and open supportive person you could ever meet and ask for whether it be looking for a first home or any home. Highly recommend Chris for all your real estate needs.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Todd Pierog",
    rating: 5,
    text: "Five-star service!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Eva Board",
    rating: 5,
    text: "Amazing! Quick responses and keeps me up to date with what's going on. Always goes the extra mile! Buying and selling felt easy peasy with Chris helping us out :)",
    location: "Grays Harbor, WA",
    type: "Buyer & Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Ross Baker",
    rating: 5,
    text: "Great experience working with Chris!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Camille Bonnell",
    rating: 5,
    text: "Chris helped me to purchase a new home. He was a steady, proactive presence throughout the entire process. His communication and dedication made everything smooth.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Michael Troy",
    rating: 5,
    text: "Chris is an amazing realtor. He was very helpful in the sale of our home in Elma. He knew the market and helped us get top dollar. Made our move to Montesano seamless.",
    location: "Elma, WA",
    type: "Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Lise Wood",
    rating: 5,
    text: "Excellent service!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Jen Gillies",
    rating: 5,
    text: "We used Chris to purchase a home with my mom after my father passed away. He was an amazing realtor and was by our side every step of the way. We are blessed with our home in Aberdeen. We are making new memories.",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Josh Apato",
    rating: 5,
    text: "Chris was invaluable as a realtor when we were planning to relocate to Aberdeen from another state. He made the viewing and buying process incredibly smooth and easy.",
    location: "Aberdeen, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Chase Simpson",
    rating: 5,
    text: "Best realtor to have. I was referred to him for my first home I purchased in Hoquiam and it was nothing but a great time with him. Highly recommend!",
    location: "Hoquiam, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Ada Allen",
    rating: 5,
    text: "Chris, without a doubt one of the best realtors I have ever worked with. Sold my home in less than a month, always available when I had to communicate, I would highly recommend!",
    location: "Grays Harbor, WA",
    type: "Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Jannessy Espanola",
    rating: 5,
    text: "Working with Chris as our buyer's agent was great. From start to finish, they were knowledgeable, responsive, and dedicated to helping us find the perfect home.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Mike & Cheri Brown",
    rating: 5,
    text: "Chris was a great realtor to work with! Kept us updated every step of the way while selling our house. I would definitely recommend him. Sold my mom's place in a short time.",
    location: "Grays Harbor, WA",
    type: "Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Alissa Cole",
    rating: 5,
    text: "He's a great realtor that helped us sell our house when we needed to in Lacey Washington!",
    location: "Lacey, WA",
    type: "Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Scott Cole",
    rating: 5,
    text: "Great realtor that helped us sell our house in Lacey Washington!",
    location: "Lacey, WA",
    type: "Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Tatton Hensley",
    rating: 5,
    text: "Working with Chris to sell our house was great. He was our realtor when we sold our home in Hoquiam recently. The renovation suggestions and help locating contractors made all the difference.",
    location: "Hoquiam, WA",
    type: "Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Connie",
    rating: 5,
    text: "Was great to work with!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Lisa Jensen",
    rating: 5,
    text: "Wonderful experience!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Lance Cox",
    rating: 5,
    text: "Chris went far & beyond in the sale of our Cosmopolis home, to purchasing our new home in Montesano.",
    location: "Montesano, WA",
    type: "Buyer & Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "M. Bronnes",
    rating: 5,
    text: "My realtor Chris Pierog was extremely helpful in finding me a new home in Ocean Shores WA. Anyone that is in the real estate market should definitely contact Chris. Highly recommend!",
    location: "Ocean Shores, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Susie Self",
    rating: 5,
    text: "Chris was super helpful during the process of buying a house in Monte and has continued to be helpful with advice and recommendations afterwards!",
    location: "Montesano, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Greg Krigbaum",
    rating: 5,
    text: "Really appreciate the 5-star service and great experience!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Carole Hall",
    rating: 5,
    text: "My experience with Chris was great. Sadly I lost my husband at the end of 2024 and had to sell my big house. Chris was compassionate and professional throughout the entire process.",
    location: "Grays Harbor, WA",
    type: "Seller",
    date: "Jan 2026",
    source: "Google"
  },
  {
    name: "Justin Philbrick",
    rating: 5,
    text: "Chris is an Awesome guy and makes your entire buying process smooth and easy. I can't recommend him enough! By far one of the best decisions I have ever made to go through Chris when buying my home!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Sep 2025",
    source: "Google"
  },
  {
    name: "Hannah Pierog",
    rating: 5,
    text: "Chris goes above and beyond for every transaction. His knowledge on our local market is a huge advantage for any investor and home buyer looking to buy in the area.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Sep 2025",
    source: "Google"
  },
  {
    name: "Isaac Hanes",
    rating: 5,
    text: "Best realtor, best in Grays Harbor, best Chris! Truly blessed to work with this guy, thank you for everything you do man, a blessing to your friends, family, and the people that need you.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Sep 2025",
    source: "Google"
  },
  {
    name: "Carter Ness",
    rating: 5,
    text: "I've worked with Chris on multiple transactions and it has always been a great experience. Chris is professional, knowledgeable, and always puts his clients first.",
    location: "Grays Harbor, WA",
    type: "Buyer & Seller",
    date: "Sep 2025",
    source: "Google"
  },
  {
    name: "Shea",
    rating: 5,
    text: "Chris was so amazing and helpful. He met me on a moment's notice to go tour a property. He was very insightful, honest, and communicated very well through the entire process. I would highly recommend Chris to anyone!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Sep 2025",
    source: "Google"
  },
  {
    name: "Christian Laines",
    rating: 5,
    text: "Chris did a great job in listing my property and getting it sold. He was very knowledgeable, advised on specific improvements, and his marketing was top-notch.",
    location: "Grays Harbor, WA",
    type: "Seller",
    date: "Aug 2025",
    source: "Google"
  },
  {
    name: "F S",
    rating: 5,
    text: "I worked with Chris on two deals. In both cases he was very knowledgeable of the area, the comps and provided great guidance throughout the process.",
    location: "Grays Harbor, WA",
    type: "Buyer & Seller",
    date: "Dec 2024",
    source: "Google"
  },
  {
    name: "Bradly Morgan",
    rating: 5,
    text: "Chris was great and made our home buying experience as effortless as possible. Highly recommend!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Dec 2024",
    source: "Google"
  },
  {
    name: "Arne Peterson",
    rating: 5,
    text: "The very best realtor in Grays Harbor.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jun 2024",
    source: "Google"
  },
  {
    name: "Darlene Hutsell",
    rating: 5,
    text: "Chris helped us find a home. I told him what I needed for my mom, he worked hard on trying to find what would fit us. Excellent service and dedication.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "May 2024",
    source: "Google"
  },
  {
    name: "Deborah Lambott",
    rating: 5,
    text: "Working with Chris was such a great experience! He always kept us informed on where we were at in the process and made everything smooth and stress-free.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Mar 2024",
    source: "Google"
  },
  {
    name: "Lisa",
    rating: 5,
    text: "Chris is the Best! Was always available when we needed him and He went above and beyond to find the right house. Will be telling all friends and family buying or selling Chris is the guy for them.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2024",
    source: "Google"
  },
  {
    name: "Niraj Dhanani",
    rating: 5,
    text: "Chris is a very professional and friendly. He knows the market and will get the job done.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jan 2024",
    source: "Google"
  },
  {
    name: "Edary Lavilla",
    rating: 5,
    text: "Chris is a great agent, always looking to help and educate his clients so they can make the best decision.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Dec 2023",
    source: "Google"
  },
  {
    name: "Dan Wood",
    rating: 5,
    text: "Multiple purchases and sales represented by him for personal homes and work places. Chris has always delivered exceptional service and results.",
    location: "Grays Harbor, WA",
    type: "Buyer & Seller",
    date: "Jun 2023",
    source: "Google"
  },
  {
    name: "Warren Backholm",
    rating: 5,
    text: "Chris is simply the best real estate agent I've ever known. Works hard to get you the best deal possible. Not surprised he's one of the top agents in Grays Harbor.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jun 2023",
    source: "Google"
  },
  {
    name: "Wyatt Backholm",
    rating: 5,
    text: "Chris is the best real estate agent in Grays Harbor. He is an exceptional communicator, diligent to see every task through, and genuinely cares about his clients.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jun 2023",
    source: "Google"
  },
  {
    name: "Sherri K",
    rating: 5,
    text: "Chris is a go-getter, very reliable. If you need something done, he can take care of it!",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jun 2023",
    source: "Google"
  },
  {
    name: "Christine Heinitz",
    rating: 5,
    text: "Chris is a great realtor. He was always available to answer any questions and he is honest and experienced. I very much recommend him for all your real estate needs.",
    location: "Grays Harbor, WA",
    type: "Buyer",
    date: "Jun 2023",
    source: "Google"
  },
];

const ALL_REVIEWS = [...ZILLOW_REVIEWS, ...GOOGLE_REVIEWS];

const ReviewCard = ({ review }) => (
  <div className="bg-white p-6 shadow-sm border border-[#e2e5e2] h-full flex flex-col" data-testid="review-card">
    <div className="flex items-center justify-between mb-4">
      <div className="flex gap-0.5">
        {[...Array(review.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-xs text-[#4d6153] bg-[#f0efeb] px-2 py-1 rounded">{review.type}</span>
        <span className={`text-xs px-2 py-1 rounded ${
          review.source === "Zillow" 
            ? "bg-blue-50 text-blue-600" 
            : "bg-green-50 text-green-600"
        }`}>
          {review.source}
        </span>
      </div>
    </div>
    
    <div className="relative flex-1">
      <Quote className="w-8 h-8 text-[#e2e5e2] absolute -top-1 -left-1" />
      <p className="text-[#4d6153] leading-relaxed pl-6">
        {review.text}
      </p>
    </div>
    
    <div className="mt-4 pt-4 border-t border-[#e2e5e2]">
      <p className="font-medium text-[#132723]">{review.name}</p>
      <p className="text-sm text-[#4d6153]">{review.location} • {review.date}</p>
    </div>
  </div>
);

export default function TestimonialsPage() {
  const [filter, setFilter] = useState("all"); // all, zillow, google, buyer, seller
  
  const filteredReviews = ALL_REVIEWS.filter(review => {
    if (filter === "all") return true;
    if (filter === "zillow") return review.source === "Zillow";
    if (filter === "google") return review.source === "Google";
    if (filter === "buyer") return review.type === "Buyer" || review.type === "Buyer & Seller";
    if (filter === "seller") return review.type === "Seller" || review.type === "Buyer & Seller";
    return true;
  });

  const buyerCount = ALL_REVIEWS.filter(r => r.type === "Buyer" || r.type === "Buyer & Seller").length;
  const sellerCount = ALL_REVIEWS.filter(r => r.type === "Seller" || r.type === "Buyer & Seller").length;
  const zillowCount = ZILLOW_REVIEWS.length;
  const googleCount = GOOGLE_REVIEWS.length;

  return (
    <>
      <Helmet>
        <title>Client Testimonials & Reviews | Chris Pierog - Grays Harbor Realtor</title>
        <meta name="description" content="Read what clients say about working with Chris Pierog. 5.0 rating on Zillow and Google with 79 verified reviews from satisfied buyers and sellers in Grays Harbor and Pacific County." />
        <meta name="keywords" content="Chris Pierog reviews, Grays Harbor realtor reviews, Aberdeen WA real estate agent, Zillow reviews, Google reviews, client testimonials" />
      </Helmet>

      <div className="min-h-screen bg-[#f0efeb] flex flex-col" data-testid="testimonials-page">
        <Header />
        
        <main className="flex-1 pt-20">
          {/* Hero Section */}
          <section className="bg-[#132723] text-white py-16 md:py-20">
            <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
              <div className="flex items-center justify-center gap-2 text-white/60 text-sm mb-6">
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
                <ChevronRight className="w-4 h-4" />
                <span>Testimonials</span>
              </div>
              
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-serif leading-tight mb-6">
                What Clients Say
              </h1>
              
              {/* Rating Summary */}
              <div className="flex items-center justify-center gap-3 mb-6">
                <span className="text-4xl font-serif">5.0</span>
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
              </div>
              
              <p className="text-lg text-white/80 mb-4">
                {ALL_REVIEWS.length} verified reviews across Zillow and Google
              </p>

              {/* Source badges */}
              <div className="flex items-center justify-center gap-4 mb-8">
                <div className="bg-white/10 px-4 py-2 rounded-full">
                  <span className="text-sm">{zillowCount} Zillow Reviews</span>
                </div>
                <div className="bg-white/10 px-4 py-2 rounded-full">
                  <span className="text-sm">{googleCount} Google Reviews</span>
                </div>
              </div>

              <div className="flex items-center justify-center gap-4">
                <img 
                  src={CHRIS_PHOTO} 
                  alt="Chris Pierog" 
                  className="w-14 h-14 rounded-full object-cover object-top border-2 border-white/20"
                />
                <div className="text-left">
                  <p className="font-medium">Chris Pierog</p>
                  <p className="text-sm text-white/60">Licensed Realtor® | Spivey Realty Group</p>
                </div>
              </div>
            </div>
          </section>

          {/* Stats Bar */}
          <section className="bg-white py-8 border-b border-[#e2e5e2]">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                <div>
                  <p className="text-3xl font-serif text-[#132723]">{ALL_REVIEWS.length}</p>
                  <p className="text-sm text-[#4d6153]">Total Reviews</p>
                </div>
                <div>
                  <p className="text-3xl font-serif text-[#132723]">5.0</p>
                  <p className="text-sm text-[#4d6153]">Average Rating</p>
                </div>
                <div>
                  <p className="text-3xl font-serif text-[#132723]">{buyerCount}</p>
                  <p className="text-sm text-[#4d6153]">Happy Buyers</p>
                </div>
                <div>
                  <p className="text-3xl font-serif text-[#132723]">{sellerCount}</p>
                  <p className="text-sm text-[#4d6153]">Satisfied Sellers</p>
                </div>
              </div>
            </div>
          </section>

          {/* Featured Review */}
          <section className="py-12 md:py-16">
            <div className="max-w-4xl mx-auto px-6 md:px-12">
              <div className="bg-[#132723] text-white p-8 md:p-12 relative">
                <Quote className="w-16 h-16 text-white/10 absolute top-4 left-4" />
                <div className="relative z-10">
                  <div className="flex gap-1 justify-center mb-6">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <blockquote className="text-xl md:text-2xl text-center leading-relaxed mb-6 font-serif">
                    &ldquo;Best realtor I have hired in 30 years of home ownership. This is my 4th home - he did a fantastic job! I highly recommend him.&rdquo;
                  </blockquote>
                  <div className="text-center">
                    <p className="font-medium">Sean Sinclair</p>
                    <p className="text-sm text-white/60">Google Review • Jan 2026</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Filter Section */}
          <section className="py-8 bg-white border-b border-[#e2e5e2]">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
              <div className="flex flex-wrap items-center justify-center gap-3">
                <div className="flex items-center gap-2 text-sm text-[#4d6153] mr-4">
                  <Filter className="w-4 h-4" />
                  <span>Filter by:</span>
                </div>
                <button
                  onClick={() => setFilter("all")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    filter === "all" 
                      ? "bg-[#132723] text-white" 
                      : "bg-[#f0efeb] text-[#4d6153] hover:bg-[#e2e5e2]"
                  }`}
                  data-testid="filter-all"
                >
                  All Reviews ({ALL_REVIEWS.length})
                </button>
                <button
                  onClick={() => setFilter("zillow")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    filter === "zillow" 
                      ? "bg-blue-600 text-white" 
                      : "bg-blue-50 text-blue-600 hover:bg-blue-100"
                  }`}
                  data-testid="filter-zillow"
                >
                  Zillow ({zillowCount})
                </button>
                <button
                  onClick={() => setFilter("google")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    filter === "google" 
                      ? "bg-green-600 text-white" 
                      : "bg-green-50 text-green-600 hover:bg-green-100"
                  }`}
                  data-testid="filter-google"
                >
                  Google ({googleCount})
                </button>
                <button
                  onClick={() => setFilter("buyer")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    filter === "buyer" 
                      ? "bg-[#132723] text-white" 
                      : "bg-[#f0efeb] text-[#4d6153] hover:bg-[#e2e5e2]"
                  }`}
                  data-testid="filter-buyer"
                >
                  Buyers ({buyerCount})
                </button>
                <button
                  onClick={() => setFilter("seller")}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    filter === "seller" 
                      ? "bg-[#132723] text-white" 
                      : "bg-[#f0efeb] text-[#4d6153] hover:bg-[#e2e5e2]"
                  }`}
                  data-testid="filter-seller"
                >
                  Sellers ({sellerCount})
                </button>
              </div>
            </div>
          </section>

          {/* All Reviews Grid */}
          <section className="py-12 md:py-16 bg-[#f8f8f6]">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
              <h2 className="text-2xl md:text-3xl font-serif text-[#132723] text-center mb-4">
                {filter === "all" ? "All Client Reviews" : 
                 filter === "zillow" ? "Zillow Reviews" :
                 filter === "google" ? "Google Reviews" :
                 filter === "buyer" ? "Buyer Reviews" : "Seller Reviews"}
              </h2>
              <p className="text-center text-[#4d6153] mb-12">
                Showing {filteredReviews.length} reviews
              </p>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredReviews.map((review, index) => (
                  <ReviewCard key={index} review={review} />
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-16 md:py-20 bg-[#132723] text-white">
            <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
              <h2 className="text-2xl md:text-3xl font-serif mb-4">
                Ready to Work Together?
              </h2>
              <p className="text-white/80 mb-8 max-w-2xl mx-auto">
                Join the growing list of satisfied clients. Whether you&apos;re buying or selling, I&apos;m here to help you achieve your real estate goals.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <Button
                  asChild
                  className="bg-white text-[#132723] hover:bg-[#f0efeb] px-8 py-6 text-lg font-medium"
                >
                  <a 
                    href="https://homevalue.graysharborrealtor.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Get Your Free Home Value
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </a>
                </Button>
                
                <a 
                  href="tel:+13605810167"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-white text-white hover:bg-white hover:text-[#132723] transition-colors font-medium"
                >
                  <Phone className="w-4 h-4" />
                  (360) 581-0167
                </a>
              </div>

              <div className="flex items-center justify-center gap-4">
                <img 
                  src={CHRIS_PHOTO} 
                  alt="Chris Pierog" 
                  className="w-12 h-12 rounded-full object-cover object-top border-2 border-white/20"
                />
                <div className="text-left">
                  <p className="font-medium">Chris Pierog</p>
                  <p className="text-sm text-white/60">Spivey Realty Group</p>
                </div>
              </div>
            </div>
          </section>
        </main>
        
        <Footer />
      </div>
    </>
  );
}
